import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EditorContext } from "../containers/editor/EditorLayout";
import { EditorPanelContext } from "../containers/editor/EditorPanel";
import { resetEditorMapTooltip } from "../_helpers/utils";
import { setUsedProposalModule } from "../store/actions/companyActions";
import useProposalInUseModule from "./useProposalInUseModule";

const useDeleteWidget = () => {
  let { metadata, widgets, updateMetadata, updateWidgets, rightContextMenu, updateRightContextMenu } =
    useContext(EditorContext);

  const [deleteWidget, setDeleteWidget] = useState(false);
  const companyId = useSelector(state => state?.auth?.user?.company?.id || null);
  const dispatch = useDispatch();

  const { id: documentId } = useParams();
  const triggerInUse = useProposalInUseModule();

  useEffect(() => {
    if (!deleteWidget || !metadata.activeWidgetId) return;

    // Delete in-use items, currencies, taxes
    if (metadata?.activeWidgetType?.[0] == "pricing_tables") {
      dispatch(
        setUsedProposalModule(
          companyId,
          { document_id: documentId },
          {
            items: [],
            currencies: [],
            taxes: [],
          }
        )
      );
    }

    // Delete in-use travel suppliers
    if (metadata?.activeWidgetType?.[0] == "itinerary") {
      setTimeout(() => {
        triggerInUse("ITINERARY", metadata?.activeWidgetId, []);
      }, 10);
    }

    if (rightContextMenu.enable)
      updateRightContextMenu({
        ...rightContextMenu,
        enable: false,
      });

    let targetWidgetIdArary = [];

    metadata.activeWidgetId.forEach(id => {
      let isGroupWidget = document.getElementById(id).closest(".dhp-page-group");
      let targetId = isGroupWidget ? document.getElementById(id).closest(".dhp-root-widget").getAttribute("id") : id;
      targetWidgetIdArary.push(targetId);
    });

    let newWidget = widgets.filter(widget => !targetWidgetIdArary.includes(widget.id));

    updateWidgets(newWidget);
    updateMetadata({ ...metadata, activeWidgetId: false, activeWidgetType: false });
    setDeleteWidget(false);

    //Remove tootlip while deleting map
    resetEditorMapTooltip();
  }, [deleteWidget]);

  return setDeleteWidget;
};

export default useDeleteWidget;
